<template>
  <div>
    <app-header title="Manufacturers">
      <b-button v-router-link="{name: 'manufacturer-editor', params: { id: 'new'}}" variant="primary">
        <i class="fa fa-plus-circle" /> New Manufacturer
      </b-button>
    </app-header>
    <loading-spinner v-if="!manufacturers" />
    <b-container v-else>
      <b-row>
        <b-col>
          <search-input v-model="query" />
        </b-col>
        <b-col class="text-right">
          {{ total }} Manufacturers
        </b-col>
      </b-row>
      <b-card-group columns>
        <b-card no-body
          v-for="manufacturer in displayManufacturers"
          :key="manufacturer.id"
          v-router-link="{name:'manufacturer-detail',params:manufacturer}"
          
        >
          <!-- <img :src="'https://cdn.gokaizen.com/' + manufacturer.thumbnail" alt="" style="max-width:100%;"> -->
          <b-card-body>
            <h3>{{ manufacturer.name }}</h3>
            <p>Manufacturer</p>
          </b-card-body>
        </b-card>
      </b-card-group>
      <infinite-scrolling @infiniteHandler="infiniteHandler" />
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $search from '@/services/search';
import SearchInput from '@/components/SearchInput';
import LoadingSpinner from '@/components/LoadingSpinner';
import InfiniteScrolling from '@/components/InfiniteScrolling';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
    SearchInput,
    LoadingSpinner,
    InfiniteScrolling,
  },

  data() {
    return {
      query: '',
      manufacturers: null,
      page: 0,
      perPage: 7,
    };
  },

  computed: {
    displayManufacturers() {
      return $search(this.manufacturers, this.query).slice(0, this.perPage * this.page);
    },

    total() {
      return (this.query) ? this.displayManufacturers.length : this.manufacturers.length;
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      this.manufacturers = await $api.get('/v1/internal/manufacturers');
    },

    infiniteHandler($state) {
      if ((this.perPage * this.page) <= this.manufacturers.length) {
        this.page += 1;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
  },
};
</script>
